module.exports = __webpack_public_path__ + "static/img/blayer.3d7f31fb.png";